/**
 * Opens a URL in a new browser tab for downloading.
 * Normalises the URL by prepending `https://` when no protocol is present.
 */
export const openDownloadUrl = (url: string): void => {
  const normalised = url.startsWith("http") ? url : `https://${url}`;
  window.open(normalised, "_blank", "noopener,noreferrer");
};
